import { render, staticRenderFns } from "./BlockFlash.vue?vue&type=template&id=a1510832"
import script from "./BlockFlash.vue?vue&type=script&lang=js"
export * from "./BlockFlash.vue?vue&type=script&lang=js"
import style0 from "./BlockFlash.vue?vue&type=style&index=0&id=a1510832&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports